import { Lock } from 'lucide-react'
import { cn } from '@/lib/utils'

interface HorizontalTabProps {
  label: string
  active: boolean
  onClick: () => void
  /** Plan-locked: mark it, but keep it clickable so the click can sell. */
  locked?: boolean
}

export function HorizontalTab({ label, active, onClick, locked }: HorizontalTabProps) {
  return (
    <button
      role="tab"
      aria-selected={active}
      onClick={onClick}
      className={cn(
        'shrink-0 whitespace-nowrap px-3 py-1.5 text-[11px] font-medium tracking-wide transition-colors select-none border-b-2 -mb-px',
        active
          ? 'text-foreground border-foreground'
          : 'text-muted-foreground hover:text-foreground border-transparent',
        locked && 'inline-flex items-center gap-1',
      )}
    >
      {label}
      {/* aria-hidden so the tab's accessible name stays the plain label. */}
      {locked && <Lock className="h-3 w-3 text-muted-foreground" aria-hidden="true" />}
    </button>
  )
}
